import moment from "moment";

export const hasEnded = (time: Date) => moment(time).diff(new Date()) <= 0;
